import React, { forwardRef } from 'react';
import { DialogTitle } from '@mui/material';
import InternationalText from './InternationalText';

const FitDialogTitle = forwardRef(function FitDialogTitle({ children, ...props }, ref) {
    const isPlainTitle = typeof children === 'string' || typeof children === 'number';
    return <DialogTitle {...props} ref={ref}>
        {isPlainTitle ? <InternationalText component="span" sx={{ display: 'block', font: 'inherit' }}>{children}</InternationalText> : children}
    </DialogTitle>;
});
export default FitDialogTitle;
